import Project from "../project"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import ProjectPropertiesFactory from "../properties/properties-factory";

// const debug = "projectApplyDelta"
const debug = false

export function projectApplyDelta(project:Project, data:any) {

    debug && console.log(debug, "applyDelta()", data)

    let isChanged = false

    const ignoredParamsForIsChangedState = ['latestActivityDate']

    _.mapKeys(data, (value ,key)=>{
        if (['id'].includes(key)) return;

        debug && console.log("applyDelta key=", key, "value=", value)

        // Normalize values i.e. date->moment
        switch (key) {
            case 'deadline'     :
            case 'startDate'    :
            case 'endDate'      :
            case 'dateCreated'  :
            case 'momentCreated': value = DatetimeUtils.dateToMoment(value)
        }

        // path names difference (backend vs js model)
        let paramName
        switch (key) {
            case 'momentCreated'        : paramName = 'dateCreated'; break
            case 'projectOwnerUserId'   : paramName = 'ownerUserId'; break
            case 'descriptionRtf'       : paramName = 'descriptionRTF'; break
            default                     :
                paramName = key
        }

        // Special case for projectOwnerUserId - old version I think it can be improved but ok...
        if (key === 'projectOwnerUserId') {
            const ownerUser = _.find(project.users, user=>user.role === gd.const.project.role.OWNER)
            if ((ownerUser && ownerUser.id !== value) || (!!ownerUser && !value) || (!ownerUser && !!value)) {
                project.setOwnerUser(value)
                isChanged = true;
            }
            return
        }

        if (key === 'properties') {
            project.properties = ProjectPropertiesFactory.get(data.systemType || project.systemType, data.properties, project)
            return
        }

        // @ts-ignore
        debug && console.log("applyDelta _isSameValue", _isSameValue(paramName, value), project[paramName], value)

        if (!_isSameValue(project, paramName, value)) {

            // @ts-ignore
            project[paramName] = value

            if (!ignoredParamsForIsChangedState.includes(paramName)) {
                isChanged = true
                project.updatedFields.delete(paramName)
            }
        }
    });

    debug && console.log("....applyDelta isChanged", isChanged)

    return isChanged

}

function _isSameValue(project:Project, paramName:any, value:any) {
    // @ts-ignore
    if (Moment.isMoment(project[paramName])) {
        // console.log("isSameValue", DatetimeUtils.momentToDate(project[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(project[paramName], DatetimeUtils.dateToMoment(value), 'day'))
        // @ts-ignore
        return DatetimeUtils.isSame(project[paramName], DatetimeUtils.dateToMoment(value), 'day')
    } else {
        // @ts-ignore
        return _.isEqual(project[paramName],value)
    }
}